define((require) => {
    "use strict";

    var Action                = require("editor/util/Action"),
        Backbone              = require("backbone"),
        _                     = require("underscore"),
        ExperienceURLProvider = require("ui/experience/ExperienceURLProvider");

    /**
     * Action that navigates to a specified experience.
     */
    return Action.extend({

        _sceneNumber: null,

        constructor: function(sceneNumber) {
            this.__super();

            this._sceneNumber = sceneNumber || 1;
        },

        _performExecution: function(experience, options) {
            if (typeof experience === "undefined") return;

            var id = _.isString(experience) ? experience : experience.get("id");

            if (id) {
                if (options && options.navigateTo) {
                    id = options.navigateTo.get("id");
                }

                this._navigate(this._getUrl(id));
            }
        },

        _getUrl: function(experienceId) {
            return ExperienceURLProvider.provide(experienceId, ExperienceURLProvider.ACTION.EDIT, this._sceneNumber);
        },

        _navigate: function(url) {
            Backbone.history.navigate(url, {trigger: true, replace: true});
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/NavigateToExperienceAction.js